import { Amount } from "@goodfill/domain-properties/src";
import React from "react";
import { formatCurrencyAmount } from "@goodfill/format-number";

export const formatMinimumInvestment = ({ value }: { value: Amount }) =>
  formatCurrencyAmount({
    value: value.toFixed(0),
    numDecimals: 0,
  });

export const MinimumInvestmentComponent = (props: { value: Amount }) => <>{formatMinimumInvestment(props)}</>;
